import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const WebDesign = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "Design comes from strategy, not aesthetics. Before we sketch a single layout, we get clear on what the site needs to achieve, who it's talking to, and what 'success' looks like in your context. We then design content-first — because beautiful layouts filled with placeholder copy are a lie — and iterate through wireframes, visual design, and prototype before a line of code is written.",
    },
    {
      title: 'Delivery',
      description:
        "Complete web design ready for development (or built by us — see Web Development): sitemap and page architecture, wireframes, full visual design in Figma, mobile and desktop responsive layouts, and a design system to keep things consistent as your site grows. Handed over with specs, assets, and everything a developer needs to build it right.",
    },
    {
      title: 'Results',
      description:
        "Websites that convert better, bounce less, and give your business the digital credibility it deserves. Clients consistently report that a well-designed site changes how new leads show up to conversations — they arrive already warm, already trusting, already half-convinced.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="Web Design Services | Heretic Studio"
        description="From strategy to execution, we design websites that balance business goals with user needs. The result is fast, accessible, and engaging digital experiences that perform in the real world."
      />
      <div className="studio-page service-page service-page--web-design">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">Web Design</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Websites that do the job beautifully</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Fast, accessible, and engaging digital experiences that perform in the real world
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default WebDesign;
